import { Language } from 'interfaces/Language'

export const getAIVideo = (locale: Language, index: number) => {
    const internalLocale = locale === Language.German ? 'de' : 'en'
    switch (index) {
        case 1:
            return `https://static.knowunity.com/assets/knowunity-ai/1_my_ai_vcp_${internalLocale}.mp4`
        case 2:
            return `https://static.knowunity.com/assets/knowunity-ai/2_my_ai_customized_${internalLocale}.mp4`
        case 3:
            return `https://static.knowunity.com/assets/knowunity-ai/3_scan_results_${internalLocale}.mp4`
        case 4:
            return `https://static.knowunity.com/assets/knowunity-ai/4_us_quiz_Flow_${internalLocale}.mp4`
        case 5:
            return `https://static.knowunity.com/assets/knowunity-ai/5_tutoring_session_${internalLocale}.mp4`
        case 6:
            return `https://static.knowunity.com/assets/knowunity-ai/6_studyplan_${internalLocale}.mp4`
        case 7:
            return `https://static.knowunity.com/assets/knowunity-ai/7_tutoring_audio_${internalLocale}.mp4`
        default:
            throw new Error(`Unknown index: ${index}`)
    }
}
